import { GlobalStyle } from "@/styles/theme/rebrand2022";
import components from "./components";

const colors = {
  white: '#FFFFFF',
  charcoal: '#202020',
  // french: '#2B8CC5',
  french: '#206892', //accessible french
  oatmilk: '#F9F3E5',
  lightOatmilk: '#FBF9F3',
  mist: '#D2E0EA',
  newPromo: '#A45A49',
  limoncello: '#E2EBA7',
  // caramel: '#B5794C',
  caramel: '#9F6A41', //accessible caramel
  olive: '#666023',
  // mud: '#b5794c',
  mud: '#9F6A41', //accessible mud
  // orange: '#ec884e',
  orange: '#C25414', //accessible orange
  // bluelink: '#2b87c5',
  bluelink: '#277CB4', //accessible bluelink
  corn: '#fff380',
  gray: '#cccccc'
}

export default {
  id: 'rebrand-2022',
  old: false,
  colors,
  fonts: {
    primary: 'Graphik',
    secondary: {
      family: 'SainteColombe',
      weight: 300,
      letterSpacing: '-0.035em'
    }
  },
  buttons: {
    primary: {
      fontSize: '18px',
      fontWeight: 400,
      letterSpacing: 0,
      backgroundColor: colors.olive,
      color: colors.white,
      borderRadius: '30px',
      height: '46px',
      border: 'none',
      textDecoration: 'underline',
      disabled: {
        backgroundColor: colors.olive,
        color: colors.white,
        border: 'none',
      },
      hover: {
        backgroundColor: colors.olive,
        color: colors.white,
        border: 'none',
      }
    },
    secondary: {
      backgroundColor: colors.limoncello,
      color: colors.charcoal,
      border: 'none',
      disabled: {
        backgroundColor: colors.limoncello,
        color: colors.charcoal,
        border: 'none',
      },
      hover: {
        backgroundColor: colors.limoncello,
        color: colors.charcoal,
        border: 'none',
      }
    },
    link: {
      color: colors.caramel
    }
  },
  components,
  globalStyles: GlobalStyle
}
